import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { AppService } from '../../../../../main/content/services/app.service';

@Component({
    selector: 'fuse-nav-vertical-item',
    templateUrl: './nav-vertical-item.component.html',
    styleUrls: ['./nav-vertical-item.component.scss']
})
export class FuseNavVerticalItemComponent implements OnInit {
    @HostBinding('class') classes = 'nav-item';
    @Input() item: any;

    
    constructor(
    public appService: AppService ) {
    }

    ngOnInit() {
    }

    routeChange(pageId, e, pageNamem,parentId) {
        sessionStorage.setItem('ParentTypeId', "0");      
        if (typeof pageId != 'undefined' && pageId != '') {
            sessionStorage.setItem('MasterTypeId', pageId);            
        }
        if (typeof parentId != 'undefined' && parentId != '') {
            sessionStorage.setItem('ParentTypeId', parentId);            
        }  
        if (typeof pageNamem != 'undefined' && pageNamem != '') {
            sessionStorage.setItem('pageName', pageNamem);            
        }      
    }

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.ts